import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
const buyers = [{
  name: 'Carlos',
  city: 'Madrid'
}, {
  name: 'Javier',
  city: 'Valencia'
}, {
  name: 'David',
  city: 'Sevilla'
}, {
  name: 'Alejandro',
  city: 'Barcelona'
}, {
  name: 'Miguel',
  city: 'Bilbao'
}, {
  name: 'Pablo',
  city: 'Zaragoza'
}, {
  name: 'Sergio',
  city: 'Málaga'
}, {
  name: 'Raúl',
  city: 'Alicante'
}];
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000); // Every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-2xl p-3 flex items-center space-x-3 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500 border-l-4 border-green-500" data-id="element-180">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-181">
        <MapPin className="w-5 h-5 text-green-600" data-id="element-182" />
      </div>
      <div data-id="element-183">
        <p className="text-xs text-gray-500" data-id="element-184">Alguien acaba de comprar</p>
        <p className="text-sm font-bold text-gray-900" data-id="element-185">
          {currentBuyer.name} de {currentBuyer.city}, España
        </p>
        <p className="text-xs text-green-600 font-semibold" data-id="element-186">
          Hace unos minutos
        </p>
      </div>
    </div>;
}